import { render, staticRenderFns } from "./Caixa.vue?vue&type=template&id=f73ba40c&scoped=true&"
import script from "./Caixa.vue?vue&type=script&lang=js&"
export * from "./Caixa.vue?vue&type=script&lang=js&"
import style0 from "./Caixa.vue?vue&type=style&index=0&id=f73ba40c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f73ba40c",
  null
  
)

export default component.exports